import { assoc, dissoc, evolve, find, is, isNil, map, pathOr, prop, propOr, when } from 'ramda';
import { notEqual } from 'ramda-adjunct';
export * from '../../shared/documentHistoriesConstants';
// Re-export the shared placement helpers so existing consumers (useWidget, tests)
// keep importing them from this module. Single source of truth lives in shared/.
export { sectionLabelFromIndex, buildWidgetPlacements } from '../../shared/documentHistoriesPlacements';

export const buildEntry = ({
  action,
  targetType,
  sectionIndex,
  rowIndex,
  widgetIndex,
  block,
  widgetId,
  targetName,
  previousName,
  placements
}) => ({
  action,
  targetType,
  // sectionIndex/rowIndex/widgetIndex must be an Int for the GraphQL
  // DocumentHistoryEntryInput. UI sources can hand it over as a string (e.g. AntD
  // Tabs keys, which are always strings), so coerce here at the single
  // entry-building choke point rather than at every call site.
  sectionIndex: isNil(sectionIndex) ? null : Number(sectionIndex),
  rowIndex: isNil(rowIndex) ? null : Number(rowIndex),
  // Position of the widget inside its row. Together with rowIndex it identifies
  // the slot, which is what tells two distinct widget placements of one section
  // apart when collapsing consecutive entries.
  widgetIndex: isNil(widgetIndex) ? null : Number(widgetIndex),
  block: isNil(block) ? null : block,
  widgetId: isNil(widgetId) ? null : widgetId,
  targetName: isNil(targetName) ? null : targetName,
  previousName: isNil(previousName) ? null : previousName,
  placements: isNil(placements) ? [] : placements
});

const normaliseWidgetSnapshot = (snapshot) =>
  evolve(
    {
      contents: when(
        is(Array),
        map(when(
          (el) => prop('type', el) === 'signature',
          assoc('type', 'text')
        ))
      )
    },
    dissoc('name', snapshot)
  );

export const hasWidgetContentChanged = (initialSnapshot, finalState) =>
  notEqual(
    normaliseWidgetSnapshot(initialSnapshot),
    normaliseWidgetSnapshot(finalState)
  );

export const firstRowWidgetId = (row) => {
  const widget = find(
    (w) => !isNil(prop('widgetId', w)),
    pathOr([], ['widgets'], row)
  );
  return isNil(widget) ? null : propOr(null, 'widgetId', widget);
};

// itemPathPrefix is `[...dataItemPrefix, 'pages', sectionIndex, type]` where
// dataItemPrefix = reject(isNil, [offerId, documentId]) — so its length varies
// (1 without a documentId, 2 with one). The widget origin (sectionIndex + block)
// therefore lives in the LAST TWO positions, never at fixed indices [2]/[3].
// Read them from the tail so the extraction is independent of dataItemPrefix size.
export const originFromItemPath = (itemPathPrefix = []) => ({
  sectionIndex: itemPathPrefix[itemPathPrefix.length - 2],
  block: itemPathPrefix[itemPathPrefix.length - 1]
});
